module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel_ALLERGIEN.ad83c159.png";